import regexpValidatorFactory from './regexp-validator-factory'

// from http://stackoverflow.com/a/1373724/393274 (the second "practical" version)
// Added ^ and $ to catch extra non-matching characters
// #35000 Update: Now modified to include query parameters.

var regExp = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])(?:\?[^&]+=[^&]*(?:&[^&]+=[^&]*)*)*$/i
/*
Note (Nate): Attempted a lookahead to allow comma-delimited addresses ((?!=,)EmailRegex)+ but proved over complicated
It is up to the caller to individually validate e-mails when more than one is accepted in an input (i.e. select)
see send-to-email-form.js for example
 */

var invalidKey = 'common.error.email.tooltip'

const regexpValFactory = regexpValidatorFactory(regExp, invalidKey)
regexpValFactory.regExp = regExp

export default regexpValFactory
regexpValFactory.__filename__ = 'components/validators/email-validator.js'
